import { Typography } from 'antd';
import { Trans } from 'react-i18next';

export const QuestionnaireSuccess = () => {
	return (
		<Trans
			i18nKey="quizSuccessText"
			components={{
				title: <Typography.Title level={5} />,
				text: <p />,
			}}
		/>
	);
};
